import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
import type { XtdhSelectedTokenDescriptor } from "../types";
interface UseXtdhTokenSelectionResult {
  readonly selectedToken: XtdhSelectedTokenDescriptor | null;
  readonly selectToken: (selection: XtdhSelectedTokenDescriptor) => void;
  readonly clearSelectedToken: () => void;
}
export function useXtdhTokenSelection() {
  const $ = _c(4);
  const [selectedToken, setSelectedToken] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = selection => {
      setSelectedToken(selection);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const selectToken = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setSelectedToken(null);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const clearSelectedToken = t1;
  let t2;
  if ($[2] !== selectedToken) {
    t2 = {
      selectedToken,
      selectToken,
      clearSelectedToken
    };
    $[2] = selectedToken;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}